<div class="crm-page sales-orders-page">
  <app-header
    [title]="'TITLES.SALES_ORDERS' | translate"
    [subtitle]="'COMPONENTS.SALES_ORDERS.LIST_SUBTITLE' | translate"
  >
    <div header-actions class="crm-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="crm-page__toolbar-bar">
    <div class="crm-toolbar">
      <div class="crm-toolbar__row">
        <div class="crm-list-search form-search">
          <div class="input-search">
            <input
              type="text"
              [value]="searchTerm"
              [placeholder]="'COMPONENTS.SALES_ORDERS.SEARCH_PLACEHOLDER' | translate"
              [attr.aria-label]="'COMPONENTS.SALES_ORDERS.SEARCH_PLACEHOLDER' | translate"
              (input)="onSearchChange($any($event.target).value)"
            />
            <span class="search-icon" aria-hidden="true">
              <img src="assets/img/search.svg" alt="" />
            </span>
          </div>
        </div>

        <div class="crm-toolbar__actions">
          <div
            class="crm-toolbar__view-mode-switch hidden md:inline-flex"
            role="group"
            [attr.aria-label]="'COMPONENTS.SALES_ORDERS.VIEW_MODES.SWITCH_ARIA_LABEL' | translate"
          >
            <button
              type="button"
              class="crm-toolbar__view-mode-button"
              [attr.aria-pressed]="viewMode === 'table'"
              [title]="'COMPONENTS.SALES_ORDERS.VIEW_MODES.TABLE' | translate"
              (click)="setViewMode('table')"
            >
              <span class="sr-only">{{ 'COMPONENTS.SALES_ORDERS.VIEW_MODES.TABLE' | translate }}</span>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h11A1.5 1.5 0 0 1 15 2.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 13.5v-11ZM2.5 2a.5.5 0 0 0-.5.5V5h12V2.5a.5.5 0 0 0-.5-.5h-11ZM2 6v3h12V6H2Zm0 4v3.5a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V10H2Z" />
              </svg>
            </button>
            <button
              type="button"
              class="crm-toolbar__view-mode-button"
              [attr.aria-pressed]="viewMode === 'tiles'"
              [title]="'COMPONENTS.SALES_ORDERS.VIEW_MODES.TILES' | translate"
              (click)="setViewMode('tiles')"
            >
              <span class="sr-only">{{ 'COMPONENTS.SALES_ORDERS.VIEW_MODES.TILES' | translate }}</span>
              <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h4A1.5 1.5 0 0 1 8 2.5v4A1.5 1.5 0 0 1 6.5 8h-4A1.5 1.5 0 0 1 1 6.5v-4Zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v4A1.5 1.5 0 0 1 13.5 8h-3A1.5 1.5 0 0 1 9 6.5v-4Zm-8 8A1.5 1.5 0 0 1 2.5 9h4A1.5 1.5 0 0 1 8 10.5v3A1.5 1.5 0 0 1 6.5 15h-4A1.5 1.5 0 0 1 1 13.5v-3Zm8 0A1.5 1.5 0 0 1 10.5 9h3A1.5 1.5 0 0 1 15 10.5v3A1.5 1.5 0 0 1 13.5 15h-3A1.5 1.5 0 0 1 9 13.5v-3Z" />
              </svg>
            </button>
          </div>

          @if (viewMode === 'table') {
            <div class="crm-toolbar__column-settings hidden md:inline-block">
              <button
                type="button"
                class="crm-toolbar__column-settings-button"
                aria-haspopup="menu"
                [attr.aria-expanded]="isColumnMenuOpen"
                aria-controls="sales-orders-columns-menu"
                [attr.aria-label]="'COMPONENTS.SALES_ORDERS.COLUMNS.BUTTON_LABEL' | translate"
                [title]="'COMPONENTS.SALES_ORDERS.COLUMNS.BUTTON_LABEL' | translate"
                (click)="toggleColumnMenu()"
              >
                <span class="sr-only">{{ 'COMPONENTS.SALES_ORDERS.COLUMNS.BUTTON_LABEL' | translate }}</span>
                <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
                  <path d="M2 2h12v2H2V2Zm0 5h12v2H2V7Zm0 5h12v2H2v-2Z" />
                </svg>
              </button>

              @if (isColumnMenuOpen) {
                <button
                  type="button"
                  class="crm-toolbar__column-menu-backdrop"
                  tabindex="-1"
                  [attr.aria-label]="'COMPONENTS.SALES_ORDERS.COLUMNS.BUTTON_LABEL' | translate"
                  (click)="closeColumnMenu()"
                ></button>
                <div
                  id="sales-orders-columns-menu"
                  role="menu"
                  tabindex="-1"
                  class="crm-toolbar__column-menu"
                  (keydown.escape)="closeColumnMenu()"
                >
                  <p class="crm-toolbar__column-menu-title">
                    {{ 'COMPONENTS.SALES_ORDERS.COLUMNS.DROPDOWN_TITLE' | translate }}
                  </p>
                  @for (column of columns; track column.key) {
                    <label
                      class="crm-toolbar__column-menu-item"
                      role="menuitemcheckbox"
                      [attr.aria-checked]="visibleColumns[column.key]"
                      [attr.aria-disabled]="column.locked"
                      [class.crm-toolbar__column-menu-item--locked]="column.locked"
                    >
                      <input
                        type="checkbox"
                        class="crm-toolbar__column-menu-checkbox"
                        [checked]="visibleColumns[column.key]"
                        [disabled]="column.locked"
                        [attr.aria-label]="'COMPONENTS.SALES_ORDERS.COLUMNS.TOGGLE_ARIA_LABEL' | translate"
                        (change)="toggleColumn(column.key)"
                      />
                      <span>{{ column.labelKey | translate }}</span>
                    </label>
                  }
                </div>
              }
            </div>
          }

          @if (canCreateSalesOrder$ | async) {
            <button
              type="button"
              class="crm-page__action-button crm-page__action-button--brand sales-orders-page__add-button"
              [attr.aria-label]="'COMPONENTS.SALES_ORDERS.BUTTONS.CREATE' | translate"
              [title]="'COMPONENTS.SALES_ORDERS.BUTTONS.CREATE' | translate"
              (click)="openCreateSalesOrderModal()"
            >
              <svg
                class="sales-orders-page__add-button-icon"
                viewBox="0 0 16 16"
                aria-hidden="true"
                focusable="false"
              >
                <path d="M8 2a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5h-4.5v4.5a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1 0-1.5h4.5v-4.5A.75.75 0 0 1 8 2Z" />
              </svg>
              <span class="hidden md:inline">{{ 'COMPONENTS.SALES_ORDERS.BUTTONS.CREATE' | translate }}</span>
            </button>
          }
        </div>
      </div>

      <div
        class="crm-toolbar__filters"
        role="group"
        [attr.aria-label]="'COMPONENTS.SALES_ORDERS.FILTERS.GROUP_LABEL' | translate"
      >
        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.SALES_ORDERS.FILTERS.STATUS_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.statusFilter"
            (change)="onStatusFilterChange($any($event.target).value)"
          >
            @for (option of statusOptions; track option.value) {
              <option [value]="option.value">{{ option.labelKey | translate }}</option>
            }
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.SALES_ORDERS.FILTERS.TYPE_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.typeFilter"
            (change)="onTypeFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.SALES_ORDERS.FILTERS.TYPE_ALL' | translate }}</option>
            @for (option of typeOptions; track option) {
              <option [value]="option">{{ ('COMPONENTS.GOODS.ITEM_TYPES.' + option.toUpperCase()) | translate }}</option>
            }
          </select>
        </label>

        <label class="crm-toolbar__filter">
          <span class="crm-toolbar__filter-label">{{ 'COMPONENTS.SALES_ORDERS.FILTERS.SOURCE_LABEL' | translate }}</span>
          <select
            class="crm-toolbar__filter-select"
            [value]="filterModel.sourceFilter"
            (change)="onSourceFilterChange($any($event.target).value)"
          >
            <option value="">{{ 'COMPONENTS.SALES_ORDERS.FILTERS.SOURCE_ANY' | translate }}</option>
            <option value="bc">{{ 'COMPONENTS.SALES_ORDERS.TABLE.SOURCE_BC' | translate }}</option>
            <option value="local">{{ 'COMPONENTS.SALES_ORDERS.TABLE.SOURCE_LOCAL' | translate }}</option>
          </select>
        </label>

        @if (activeFilterCount > 0) {
          <button
            type="button"
            class="crm-toolbar__filter-reset"
            (click)="resetFilters()"
          >
            <span aria-hidden="true">×</span>
            {{ 'COMPONENTS.SALES_ORDERS.FILTERS.RESET' | translate }}
            <span class="crm-toolbar__filter-count">{{ activeFilterCount }}</span>
          </button>
        }
      </div>
    </div>
  </div>

  <div class="crm-page__content px-4 py-6 md:px-8 md:py-8">
    @if (isLoading) {
      <div class="crm-page__overlay">
        <div class="sales-orders-page__spinner" aria-hidden="true"></div>
        <span class="sr-only">{{ "MESSAGES.LOADING" | translate }}</span>
      </div>
    }

    @if (rowActionErrorKey) {
      <div class="sales-orders-page__row-action-error" role="alert">
        {{ rowActionErrorKey | translate }}
      </div>
    }

    @if (errorMessageKey) {
      <app-card-shell padding="lg">
        <div class="sales-orders-page__error">
          <div>
            <h2 class="sales-orders-page__error-title">{{ "ERRORS.UNKNOWN_ERROR" | translate }}</h2>
            <p class="sales-orders-page__error-text">{{ errorMessageKey | translate }}</p>
          </div>

          <button
            type="button"
            class="crm-page__action-button"
            (click)="retry()"
          >
            {{ "BUTTONS.RETRY" | translate }}
          </button>
        </div>
      </app-card-shell>
    } @else if (salesOrders$ | async; as salesOrders) {
      @if (salesOrders.items.length === 0) {
        <app-card-shell class="crm-page__empty-card" padding="none">
          <div class="crm-page__empty-state">
            <app-empty-content
              [showImage]="true"
              [message]="'MESSAGES.EMPTY_LIST' | translate: { param: emptyListParam[currentLang] }"
              [tooltip]="'COMPONENTS.SALES_ORDERS.EMPTY_TOOLTIP' | translate"
              [textPositionClass]="'text-center'"
            />
          </div>
        </app-card-shell>
      } @else {
        <ng-template #tilesGridTpl>
          <div class="crm-tile-grid">
            @for (order of salesOrders.items; track order.id) {
              <article
                class="crm-tile crm-tile--so"
                tabindex="0"
                role="button"
                [attr.aria-label]="order.number"
                (click)="openSalesOrder(order.id)"
                (keydown.enter)="openSalesOrder(order.id)"
              >
                <span class="crm-tile__status-accent" [ngClass]="order.statusBadgeClass"></span>

                <div class="crm-tile__body">
                  <header class="crm-tile__header-row">
                    <a
                      class="crm-tile__number"
                      [routerLink]="order.id"
                      (click)="$event.stopPropagation()"
                      [title]="order.number"
                    >
                      {{ order.number }}
                    </a>
                    <span [ngClass]="order.statusBadgeClass">
                      <span class="sales-order-status-badge__dot" aria-hidden="true"></span>
                      {{ order.statusLabelKey | translate }}
                    </span>
                  </header>

                  @if (order.hasShortDescription) {
                    <p class="crm-tile__description">{{ order.shortDescription }}</p>
                  }

                  @if (order.hasCustomerType) {
                    <p class="crm-tile__client-title" [title]="order.clientTitle">
                      {{ order.clientTitle }}
                    </p>
                    <p class="crm-tile__client-type">
                      {{ order.customerTypeLabelKey | translate }}
                    </p>
                  }

                  <div class="crm-tile__meta-row">
                    @if (order.hasType) {
                      <span [ngClass]="order.typeBadgeClass">
                        {{ order.typeLabelKey | translate }}
                      </span>
                    }
                    <span [ngClass]="order.sourceBadgeClass">
                      {{ order.sourceLabelKey | translate }}
                    </span>
                  </div>

                  <div class="crm-tile__total-row">
                    <div>
                      <p class="crm-tile__label">{{ 'COMPONENTS.SALES_ORDERS.TABLE.TOTAL' | translate }}</p>
                      <p class="crm-tile__total">
                        {{ order.amountIncludingTax | number: '1.2-2' }}
                        @if (order.hasCurrencyCode) {
                          <span class="sales-orders-page__total-currency">{{ order.currencyCode | currencySymbol }}</span>
                        }
                      </p>
                    </div>
                    <p class="crm-tile__date">
                      {{ order.createdAt ? (order.createdAt | date: 'yyyy-MM-dd') : '-' }}
                    </p>
                  </div>

                  <button
                    type="button"
                    class="crm-tile__open-button"
                    (click)="$event.stopPropagation(); openSalesOrder(order.id)"
                  >
                    {{ 'BUTTONS.OPEN' | translate }}
                  </button>
                </div>
              </article>
            }
          </div>
        </ng-template>

        @if (viewMode === 'table') {
          <section class="crm-page__table-section">
            <app-card-shell class="crm-page__list-card" padding="none">
              <div class="crm-table__desktop">
                <div class="crm-table__scroller">
                  <table class="crm-table__table">
                    <thead>
                      <tr class="crm-table__header-row">
                        @if (visibleColumns.number) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="number"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.NUMBER" | translate }}
                          </th>
                        }
                        @if (visibleColumns.description) {
                          <th class="crm-table__header-cell">
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.DESCRIPTION" | translate }}
                          </th>
                        }
                        @if (visibleColumns.client) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="organizationtitle"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.CLIENT" | translate }}
                          </th>
                        }
                        @if (visibleColumns.type) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="type"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.TYPE" | translate }}
                          </th>
                        }
                        @if (visibleColumns.status) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="status"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.STATUS" | translate }}
                          </th>
                        }
                        @if (visibleColumns.total) {
                          <th
                            class="crm-table__header-cell crm-table__header-cell--right"
                            appSortableHeader="total"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.TOTAL" | translate }}
                          </th>
                        }
                        @if (visibleColumns.source) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="source"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.SOURCE" | translate }}
                          </th>
                        }
                        @if (visibleColumns.responsible) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="responsible"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.RESPONSIBLE" | translate }}
                          </th>
                        }
                        @if (visibleColumns.date) {
                          <th
                            class="crm-table__header-cell"
                            appSortableHeader="createdAt"
                            [appSortableHeaderActiveColumn]="activeSortColumn"
                            [appSortableHeaderActiveOrder]="activeSortOrder"
                            (appSortableHeaderChange)="onSortChange($event)"
                          >
                            {{ "COMPONENTS.SALES_ORDERS.TABLE.DATE" | translate }}
                          </th>
                        }
                        <th class="crm-table__header-cell crm-table__header-cell--actions">
                          <span class="sr-only">{{ "COMPONENTS.SALES_ORDERS.TABLE.ACTIONS" | translate }}</span>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      @for (salesOrder of salesOrders.items; track salesOrder.id) {
                        <tr class="crm-table__row">
                          @if (visibleColumns.number) {
                            <td class="crm-table__cell crm-table__cell--title">
                              <a [routerLink]="salesOrder.id" [title]="salesOrder.number">
                                {{ salesOrder.number }}
                              </a>
                            </td>
                          }
                          @if (visibleColumns.description) {
                            <td
                              class="crm-table__cell sales-orders-page__description-cell"
                              [title]="salesOrder.shortDescription"
                            >
                              @if (salesOrder.hasShortDescription) {
                                <span>{{ salesOrder.shortDescription }}</span>
                              } @else {
                                <span class="sales-orders-page__muted">—</span>
                              }
                            </td>
                          }
                          @if (visibleColumns.client) {
                            <td class="crm-table__cell sales-orders-page__client-cell">
                              @if (salesOrder.hasCustomerType) {
                                <span
                                  class="sales-orders-page__client-title"
                                  [title]="salesOrder.clientTitle"
                                >
                                  {{ salesOrder.clientTitle }}
                                </span>
                                <span class="sales-orders-page__client-type">
                                  {{ salesOrder.customerTypeLabelKey | translate }}
                                </span>
                              } @else {
                                <span class="sales-orders-page__muted">—</span>
                              }
                            </td>
                          }
                          @if (visibleColumns.type) {
                            <td class="crm-table__cell">
                              @if (salesOrder.hasType) {
                                <span [class]="salesOrder.typeBadgeClass">
                                  {{ salesOrder.typeLabelKey | translate }}
                                </span>
                              } @else {
                                <span class="sales-orders-page__muted">—</span>
                              }
                            </td>
                          }
                          @if (visibleColumns.status) {
                            <td class="crm-table__cell">
                              <span [class]="salesOrder.statusBadgeClass">
                                <span class="sales-order-status-badge__dot" aria-hidden="true"></span>
                                {{ salesOrder.statusLabelKey | translate }}
                              </span>
                            </td>
                          }
                          @if (visibleColumns.total) {
                            <td class="crm-table__cell crm-table__cell--right sales-orders-page__total-cell">
                              {{ salesOrder.amountIncludingTax | number: "1.2-2" }}
                              @if (salesOrder.hasCurrencyCode) {
                                <span class="sales-orders-page__total-currency">{{ salesOrder.currencyCode | currencySymbol }}</span>
                              }
                            </td>
                          }
                          @if (visibleColumns.source) {
                            <td class="crm-table__cell">
                              <span [class]="salesOrder.sourceBadgeClass">
                                {{ salesOrder.sourceLabelKey | translate }}
                              </span>
                            </td>
                          }
                          @if (visibleColumns.responsible) {
                            <td
                              class="crm-table__cell sales-orders-page__responsible-cell"
                              [title]="salesOrder.responsibleName"
                            >
                              @if (salesOrder.hasResponsible) {
                                <span>{{ salesOrder.responsibleName }}</span>
                              } @else {
                                <span class="sales-orders-page__muted">—</span>
                              }
                            </td>
                          }
                          @if (visibleColumns.date) {
                            <td class="crm-table__cell" [title]="salesOrder.createdAt">
                              {{ salesOrder.createdAt ? (salesOrder.createdAt | date: "yyyy-MM-dd") : "-" }}
                            </td>
                          }
                          <td class="crm-table__cell crm-table__cell--actions">
                            <app-action-menu
                              [items]="salesOrder.actionMenuItems"
                              [disabled]="isRowActionInFlight"
                              ariaLabelKey="COMPONENTS.SALES_ORDERS.TABLE.ACTIONS"
                              (actionSelected)="onRowAction($event, salesOrder)"
                            />
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="crm-page__footer sales-orders-page__footer--desktop">
                <app-paginator
                  class="crm-page__paginator"
                  [totalItems]="salesOrders.totalCount"
                  [page]="salesOrders.page"
                  [pageSize]="salesOrders.pageSize"
                  [showSummary]="true"
                  (pageChange)="onPageChange($event)"
                  (pageSizeChange)="onChangePageSize($event)"
                />
              </div>
            </app-card-shell>
          </section>
        }

        <section
          class="crm-page__tile-section"
          [class.crm-page__tile-section--desktop-hidden]="viewMode === 'table'"
        >
          <ng-container *ngTemplateOutlet="tilesGridTpl"></ng-container>

          <div class="crm-page__footer sales-orders-page__footer--tiles">
            <app-paginator
              class="crm-page__paginator"
              [totalItems]="salesOrders.totalCount"
              [page]="salesOrders.page"
              [pageSize]="salesOrders.pageSize"
              [showSummary]="true"
              (pageChange)="onPageChange($event)"
              (pageSizeChange)="onChangePageSize($event)"
            />
          </div>
        </section>
      }
    }

    <app-reusable-modal
      [isOpen]="isCreateSalesOrderModalOpen"
      [panelClass]="'max-w-3xl'"
      [contentScoped]="true"
      [title]="'COMPONENTS.SALES_ORDERS.CREATE_MODAL_TITLE' | translate"
      (closed)="closeCreateSalesOrderModal()"
    >
      <app-create-sales-order
        [companyId]="companyId"
        (cancelled)="closeCreateSalesOrderModal()"
        (created)="onSalesOrderCreated($event)"
      />
    </app-reusable-modal>

    <app-reusable-modal
      [isOpen]="isArchiveConfirmationOpen"
      [panelClass]="'max-w-lg'"
      [contentScoped]="true"
      [title]="'COMPONENTS.SALES_ORDERS.MODAL.ARCHIVE_TITLE' | translate"
      (closed)="closeArchiveConfirmation()"
    >
      <section class="sales-orders-page__delete-confirmation">
        <p class="sales-orders-page__delete-confirmation-prompt">
          {{ 'COMPONENTS.SALES_ORDERS.MODAL.ARCHIVE_PROMPT' | translate }}
        </p>

        @if (pendingArchiveOrder) {
          <p class="sales-orders-page__delete-confirmation-target">
            <span class="sales-orders-page__delete-confirmation-label">
              {{ 'COMPONENTS.SALES_ORDERS.TABLE.NUMBER' | translate }}:
            </span>
            <span class="sales-orders-page__delete-confirmation-value">
              {{ pendingArchiveOrder.number }}
            </span>
          </p>
        }

        <div class="sales-orders-page__delete-confirmation-actions">
          <button
            type="button"
            class="form-secondary-btn"
            [disabled]="isRowActionInFlight"
            (click)="closeArchiveConfirmation()"
          >
            {{ 'BUTTONS.BACK' | translate }}
          </button>
          <button
            type="button"
            class="sales-orders-page__archive-confirmation-btn"
            [disabled]="isRowActionInFlight"
            (click)="confirmArchive()"
          >
            @if (isRowActionInFlight) {
              {{ 'COMPONENTS.SALES_ORDERS.BUTTONS.ARCHIVING' | translate }}
            } @else {
              {{ 'COMPONENTS.SALES_ORDERS.BUTTONS.ARCHIVE_ORDER' | translate }}
            }
          </button>
        </div>
      </section>
    </app-reusable-modal>

    <app-reusable-modal
      [isOpen]="isDeleteConfirmationOpen"
      [panelClass]="'max-w-lg'"
      [contentScoped]="true"
      [title]="'COMPONENTS.SALES_ORDERS.MODAL.DELETE_TITLE' | translate"
      (closed)="closeDeleteConfirmation()"
    >
      <section class="sales-orders-page__delete-confirmation">
        <p class="sales-orders-page__delete-confirmation-prompt">
          {{ 'COMPONENTS.SALES_ORDERS.MODAL.DELETE_PROMPT' | translate }}
        </p>

        @if (pendingDeleteOrder) {
          <p class="sales-orders-page__delete-confirmation-target">
            <span class="sales-orders-page__delete-confirmation-label">
              {{ 'COMPONENTS.SALES_ORDERS.TABLE.NUMBER' | translate }}:
            </span>
            <span class="sales-orders-page__delete-confirmation-value">
              {{ pendingDeleteOrder.number }}
            </span>
          </p>
        }

        <div class="sales-orders-page__delete-confirmation-actions">
          <button
            type="button"
            class="form-secondary-btn"
            [disabled]="isRowActionInFlight"
            (click)="closeDeleteConfirmation()"
          >
            {{ 'BUTTONS.BACK' | translate }}
          </button>
          <button
            type="button"
            class="sales-orders-page__delete-confirmation-danger-btn"
            [disabled]="isRowActionInFlight"
            (click)="confirmDelete()"
          >
            @if (isRowActionInFlight) {
              {{ 'COMPONENTS.SALES_ORDERS.BUTTONS.DELETING' | translate }}
            } @else {
              {{ 'COMPONENTS.SALES_ORDERS.BUTTONS.DELETE_ORDER' | translate }}
            }
          </button>
        </div>
      </section>
    </app-reusable-modal>
  </div>
</div>
